var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1.0048828125em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1029 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1028.848398 511.974401c0 282.753222-229.210939 511.974401-511.974402 511.974402-282.758342 0-511.974401-229.221179-511.974401-511.974402 0-282.763462 229.216059-511.974401 511.974401-511.974401 282.763462 0 511.974401 229.210939 511.974402 511.974401",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M516.873996 612.439138L416.39902 511.974401l100.474976-100.474976 100.474977 100.474976zM745.20434 511.974401l-0.424939 0.4147 93.189581 93.18446 93.604279-93.604279-94.254487-94.254488-93.184461 93.184461z",
    fill: "#F4BB0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.381911 445.131023l161.492085-161.492085 163.867647 163.867647 93.179341-93.179341-257.046988-257.057228-254.676546 254.676547zM681.386731 575.786891l-164.512735 164.512734-163.053607-163.063847-93.179341 93.189581 256.232948 256.243188 257.697195-257.697196zM288.548773 511.974401l3.440468-3.445587L198.79966 415.339233 102.179851 511.974401l95.063407 95.063407 93.179341-93.179341z",
    fill: "#F4BB0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbIcon);
export default __webpack_public_path__ + "static/media/BNB-icon.cdbc95c3a5924398a85c29a1e2fc1637.svg";
export { ForwardRef as ReactComponent };